import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function Location() {
 return (
    <SettingsMetaData propertyName={"Inspection_Location"} viewPropertyName={"Inspection Location"} />
  );
}

export default Location